.container {
  background: var(--color-grayscale-charleston);
  border: 1px solid var(--color-grayscale-trout);
  border-radius: 0.8rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1);
  overflow: auto;
  padding: 0.4rem;
  max-height: 20rem;
}

.item {
  all: unset;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  padding: 0.8rem;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  color: var(--color-grayscale-white);
  cursor: pointer;

  &[data-selected='true'] {
    background: var(--color-grayscale-trout);
  }

  &:hover {
    background: var(--color-grayscale-trout);
  }
}

.empty-item {
  padding: 0.8rem;
  font-size: 1.4rem;
  color: var(--color-grayscale-manatee);
  text-align: center;
}
